import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProctorService } from '../services/proctor.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  constructor(private proctorService: ProctorService, private activatedRoute: ActivatedRoute, private router: Router){

  }

  ngOnInit(): void {
    if(location.host == `${this.proctorService.company}.${environment.secondViewProctorDomain}`){
      this.router.navigate(['/secondview'], { queryParams: {...this.activatedRoute.snapshot.queryParams, interactive: true} });
    }
    else{
      this.router.navigate(['/proctor'], {skipLocationChange: true} );
    }
  }

}
